export default [
  {
    nome: 'Caixa de entrada',
    icon: 'fal fa-envelope',
    routeGroup: 'sala-monitoramento/caixa-entrada',
    permissao: 'VIEW_CAIXA_ENTRADA'
  },
  {
    nome: 'Em decisão',
    icon: 'fal fa-file-signature',
    routeGroup: 'sala-monitoramento/em-decisao',
    permissao: 'VIEW_CAIXA_EM_DECISAO'
  },
  {
    nome: 'Arquivadas',
    icon: 'fal fa-folder-open',
    routeGroup: 'sala-monitoramento/arquivadas',
    permissao: 'VIEW_CAIXA_ARQUIVADOS'
  }
]



// WEBPACK FOOTER //
// ./src/libs/constants/painel/sala-monitoramento/menu.js